import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const CenteredTemplateOneOneTwo = ({
  titleText = "THE BEST PRODUCT IS HERE",
  titleFont = "Montserrat",
  titleFontSize = "37",
  titleColor = "#FFFFFF",
  titleTextAlign = "center",
  titleIsBold = true,
  titleIsItalic = false,
  titleIsUnderline = false,
  titleUppercase = true,
  titleLetterSpacing = "-2px",

  subtitleText = "And it's yours today.",
  subtitleFont = "Montserrat",
  subtitleFontSize = "20",
  subtitleColor = "#FFFFFF",
  subtitleTextAlign = "center",
  subtitleIsBold = true,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  backgroundType = "color",
  backgroundColor = "#343F37",
  backgroundImage = null,

  contentImageOne = null,
  contentImageOnePreview = null,

  buttonLabel = "Get started",
  buttonFont = "Poppins",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "16",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#599E10",

  backgroundImagePreview,

  inmeeting = false,
  center = false,
  onClose,
}) => {
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  return (
    <div
      className={`relative ${
        !inmeeting ? "h-auto min-h-[283px]" : center ? "!h-[50vh]" : "!h-[15vh]"
      } w-full flex flex-col mx-auto items-center justify-between px-4 md:px-8 py-4 md:py-3 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && meetingRole === "moderator" && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Content Container */}
      <div className="relative z-10 flex flex-col h-full justify-between ">
        {/* Title Section */}
        <div className="flex items-center justify-center mb-6 md:mb-8 mt-5">
          <h1
            className={`text-center ${
              explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
            } leading-tight max-w-full`}
            style={{
              color: titleColor,
              fontSize: `${titleFontSize}px`,
              fontFamily: titleFont,
              textAlign: titleTextAlign,
              fontWeight: explicitBoleanCheck(titleIsBold) ? 900 : "normal",
              textTransform: titleUppercase ? "uppercase" : "none",
              ...(titleLetterSpacing
                ? { letterSpacing: titleLetterSpacing }
                : {}),
              whiteSpace: "pre-line",
            }}
          >
            {titleText}
          </h1>
        </div>

        {/* Bottom Section - Image and Content */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-8 lg:gap-10">
          {/* Image */}
          <div className="flex-shrink-0">
            {contentImageOne || contentImageOnePreview ? (
              <img
                src={
                  contentImageOne instanceof File
                    ? contentImageOnePreview
                    : contentImageOne
                }
                alt="Product"
                className="w-32 h-32 md:w-42 md:h-42 object-cover rounded"
              />
            ) : (
              <img
                src="/image_placeholder.png"
                alt="Product"
                className="w-22 h-22 md:w-32 md:h-32 object-contain rounded"
              />
            )}
          </div>

          {/* Text and Button */}
          <div className="flex flex-col items-center md:items-start justify-center gap-4 md:gap-5">
            <p
              className={`text-center md:text-center ${
                explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
              } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
                explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
              }`}
              style={{
                color: subtitleColor,
                fontSize: `${subtitleFontSize}px`,
                fontFamily: subtitleFont,
                textAlign: subtitleTextAlign,
              }}
            >
              {subtitleText}
            </p>

            <button
              className={`px-4 py-3 md:px-6 md:py-3 rounded-full transition-all duration-200 shadow-lg ${
                explicitBoleanCheck(buttonIsBold) ? "font-bold" : ""
              } ${explicitBoleanCheck(buttonIsItalic) ? "italic" : ""} ${
                explicitBoleanCheck(buttonIsUnderline) ? "underline" : ""
              } ${buttonLink ? "cursor-pointer" : "cursor-default"}`}
              style={{
                backgroundColor: buttonBackgroundColor,
                color: buttonFontColor,
                fontSize: `${buttonFontSize}px`,
                fontFamily: buttonFont,
              }}
              onClick={() => {
                if (buttonLink) {
                  window.open(buttonLink, "_blank");
                }
              }}
            >
              {buttonLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CenteredTemplateOneOneTwo;
